export enum ERequestOfHarvestSaleRequestName {
  CHANGE_STATUS = 'changeHarvestSaleRequestStatus',
  CHANGE = 'changeHarvestSaleRequestStatus',
  REJECT = 'rejectHarvestSaleRequest',
}
